import React, { useEffect, useState } from "react";
import { Accordion, Form } from "react-bootstrap";

function SubSection4({ slotBookingData, setSlotBookingData }) {
  const handleCheckboxNames = [
    "reorder",
    "understoodReasons",
    "importanceOfRegularity",
    "tookUpdatesOnResults",
    "explainedTheMonthlyGoals",
    "placedTheOrder",
    "deliveryRelatedConcern",
    "maintenanceCall",
    "apologisedRaisedTicket",
  ];

//     reorder: false,
//     probedRegularityUsage: "",
//     understoodReasons: false,
//     importanceOfRegularity: false,
//     tookUpdatesOnResults: false,
//     explainedTheMonthlyGoals: false,
//     placedTheOrder: false,
//     deliveryRelatedConcern: false,
//     maintenanceCall: false,
//     apologisedRaisedTicket: false,
//   });

  // Function to handle state change
  const handleCheckboxChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const checkedValue = event.target.checked;

    if (handleCheckboxNames.includes(name)) {
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: checkedValue,
      }));
    } else {
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  
  return (
    <Accordion>
      <Accordion.Item eventKey="1">
        <Accordion.Header className="border-bottom">
          Other reasons
        </Accordion.Header>
        <Accordion.Body>
          <Form.Check
            type="checkbox"
            label="Reorder"
            checked={slotBookingData?.reorder}
            onChange={handleCheckboxChange}
            className="mb-2"
            id="reorder"
            name="reorder"
          />
          {slotBookingData?.reorder && (
            <>
              <Form.Group controlId="probedRegularityUsage" className="mb-3">
                <Form.Label className="text-primary">
                  Probed on regularity of usage
                </Form.Label>
                <Form.Select
                  className="form-select"
                  value={slotBookingData?.probedRegularityUsage}
                  name="probedRegularityUsage"
                  onChange={handleCheckboxChange}
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                  <option value="partial">Partial</option>
                </Form.Select>
              </Form.Group>
              {(slotBookingData?.probedRegularityUsage === "no" ||
                slotBookingData?.probedRegularityUsage === "partial") && (
                <>
                  <Form.Check
                    type="checkbox"
                    label="Understood reasons for the same"
                    checked={slotBookingData?.understoodReasons}
                    onChange={handleCheckboxChange}
                    className="mb-2"
                    id="understoodReasons"
                    name="understoodReasons"
                  />
                  <Form.Check
                    type="checkbox"
                    label="Explained the importance of regularity and gave tips/ hacks to be regular"
                    checked={slotBookingData?.importanceOfRegularity}
                    onChange={handleCheckboxChange}
                    className="mb-2"
                    id="importanceOfRegularity"
                    name="importanceOfRegularity"
                  />
                </>
              )}
              <Form.Check
                type="checkbox"
                label="Took updates on results [Pls fill the results sub-section accordingly]"
                checked={slotBookingData?.tookUpdatesOnResults}
                onChange={handleCheckboxChange}
                className="mb-2"
                id="tookUpdatesOnResults"
                name="tookUpdatesOnResults"
              />
              <Form.Check
                type="checkbox"
                label="Celebrated the progress and explained the monthly goals (current and next one) again"
                checked={slotBookingData?.explainedTheMonthlyGoals}
                onChange={handleCheckboxChange}
                className="mb-2"
                id="explainedTheMonthlyGoals"
                name="explainedTheMonthlyGoals"
              />
              <Form.Check
                type="checkbox"
                label="Placed the order"
                checked={slotBookingData?.placedTheOrder}
                onChange={handleCheckboxChange}
                className="mb-2"
                id="placedTheOrder"
                name="placedTheOrder"
              />
            </>
          )}
          <Form.Check
            type="checkbox"
            label="Maintenance call"
            checked={slotBookingData?.maintenanceCall}
            onChange={handleCheckboxChange}
            className="mb-2"
            id="maintenanceCall"
            name="maintenanceCall"
          />
          <Form.Check
            type="checkbox"
            label="Delivery related concern"
            checked={slotBookingData?.deliveryRelatedConcern}
            onChange={handleCheckboxChange}
            className="mb-2"
            id="deliveryRelatedConcern"
            name="deliveryRelatedConcern"
          />
          {slotBookingData?.deliveryRelatedConcern && (
            <Form.Check
              type="checkbox"
              label="Apologised and raised a ticket"
              checked={slotBookingData?.apologisedRaisedTicket}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="apologisedRaisedTicket"
              name="apologisedRaisedTicket"
            />
          )}
          <hr />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default SubSection4;
